import React, { useEffect } from "react";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Dicontent from "./Dicontent";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Diser() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Dicontent />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Diabetes Treatment in Whitefield</title>
        <meta
          name="description"
          content="Looking for the best diabetes treatment in Whitefield? Then you are at the right place. Feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Diabetes Treatment in Whitefield, Best Diabetes Treatment in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id": "https://www.elvhealthcare.com/bestdiabetesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestdiabetesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert diabetes care and management, including diagnosis, personalized treatment plans, blood sugar monitoring, lifestyle guidance, and preventive approaches to help patients control and manage diabetes effectively.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Diabetes diagnosis and testing",
              "Personalized diabetes management",
              "Blood sugar monitoring",
              "Diet and lifestyle counseling for diabetes",
              "Chronic condition support and follow-up",
              "Preventive care and education",
              "Insulin therapy guidance",
            ],
            keywords: [
              "best diabetes in Immadihalli",
              "best diabetes in Whitefield",
              "best diabetes in Bangalore",
              "best diabetes in Kundalahalli",
              "best diabetes in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Diabetes Treatment in Whitefield challenges of diabetes and
        achieving a better quality of life. Contact us today for the best
        diabetes treatment in Whitefield.
      </h2>

      <Servicebanner name="Diabetes" banner={"../photo/dd6.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Diser;
